import React from "react";

import Typography from "@mui/joy/Typography";
import {Switch} from "@mui/joy";


class Boolean extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.value
        }
    }

    setChecked(){
        this.setState({
            checked: !this.state.checked
        });
    }

    render(){
        return(
            <>
                <Switch
                    checked={this.state.checked}
                    slotProps={{
                        track: {
                            children: (
                                <React.Fragment>
                                    <Typography component="span" level="inherit" sx={{ml: '10px'}}>
                                        Да
                                    </Typography>
                                    <Typography component="span" level="inherit" sx={{mr: '8px'}}>
                                        Нет
                                    </Typography>
                                </React.Fragment>
                            ),
                        },
                    }}
                    sx={{
                        '--Switch-thumbSize': '27px',
                        '--Switch-trackWidth': '64px',
                        '--Switch-trackHeight': '31px',
                    }}
                    onChange={this.setChecked.bind(this)}
                    slots={{
                        input: null,
                    }}
                />
                <input
                    style={{
                        width: '1px',
                        height: '1px',
                        margin: 0,
                        padding: 0,
                        border: 0,
                        color: 'transparent',
                    }}
                    required={this.props.required}
                    name={this.props.name}
                    checked={this.state.checked}
                    value={this.state.checked?'true':'false'}
                />
            </>
        )
    }
}

export default Boolean